import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import "./App.css";

import Home from "./components/Home/Home";
import TermsOfService from "./terms/TermsOfService";

import ForgotPassword from "./components/Password/ForgotPassword";
import ResetPasswordPage from "./components/Password/ResetPasswordPage";

import VerifyEmailPage from "./components/VerifyEmail/VerifyEmailPage";
import VerifyEmailPending from "./components/VerifyEmail/VerifyEmailPending";

import ContactPage from "./components/Contact/ContactPage.js";

import PublicUserPage from "./components/Public/PublicUserPage";
import PublicEventPage from "./components/Public/PublicEventPage";

import PrivacyPolicyPage from "./PrivacyPolicy/PrivacyPolicy.js"

function App() {
  return (
    <Routes>
      {/* Main site */}
      <Route
        path="/"
        element={<Home />}
      />

      {/* Legal / contact */}
      <Route
        path="/terms"
        element={<TermsOfService />}
      />

            <Route
        path="/privacy"
        element={<PrivacyPolicyPage />}
      />

      <Route
        path="/contact"
        element={<ContactPage />}
      />

      {/* Account recovery */}
      <Route
        path="/forgot-password"
        element={<ForgotPassword />}
      />

      <Route
        path="/reset-password"
        element={<ResetPasswordPage />}
      />

      {/* Email verification */}
      <Route
        path="/verify-email-pending"
        element={<VerifyEmailPending />}
      />

      <Route
        path="/verify-email"
        element={<VerifyEmailPage />}
      />

      {/* Public Veacon pages */}
      <Route
        path="/u/:username"
        element={<PublicUserPage />}
      />

      <Route
        path="/events/:eventId"
        element={<PublicEventPage />}
      />

      {/* Keep this LAST */}
      <Route
        path="*"
        element={
          <Navigate
            to="/"
            replace
          />
        }
      />
    </Routes>
  );
}

export default App;